import request from '..';

const SERVER = `${process.env.REACT_APP_SERVER_ENVIRONMENT}/api/v1/pss-bff-public`;

// Obtiene el detalle del vehiculo por patente
export const getDeteailsVehicleByPantent = async (patent: string) => {
  return await request({
    url: `${SERVER}/vehicles/${patent}`,
    method: 'GET',
  });
};

// Obtiene los tipos de licencias
export const getLicenseTypes = async () => {
  return await request({
    url: `${SERVER}/drivers/license-types`,
    method: 'GET',
  });
};

// Obtiene las clases de licencias
export const getLicenseClasses = async () => {
  return await request({
    url: `${SERVER}/drivers/license-classes`,
    method: 'GET',
  });
};

export const verifyByPlate = async (id: string) => {
  return await request({
    url: `${SERVER}/vehicles/theft-notification/verify-associated-claim?patent=${id}`,
    method: 'GET',
  });
};

// Valida el rut
export const validateRut = async (rut: string, patente?: string) => {
  return await request({
    url: `${SERVER}/declarants/public`,
    method: 'POST',
    data: {
      customerIdentityNumber: rut,
    },
    Headers: {
      'Content-Type': 'application/json',
    },
  });
};

// Obtiene las regiones
export const getRegions = async () => {
  return await request({
    url: `${SERVER}/locations/regions`,
    method: 'GET',
  });
};

// Obtiene las comunas
export const getCommunes = async (regionId: string) => {
  return await request({
    url: `${SERVER}/locations/communes/${regionId}`,
    method: 'GET',
  });
};

// Obtiene los tipos de sinietros
export const getAccidentTypes = async () => {
  return await request({
    url: `${SERVER}/claims/types`,
    method: 'GET',
  });
};

// Obtiene las causas de los sinietros debido a un tipo de sinietro
export const getAccidentCauses = async (accidentTypeId: string) => {
  return await request({
    url: `${SERVER}/claims/causes/${accidentTypeId}`,
    method: 'GET',
  });
};

// Obtiene la señalitica presente
export const getSignages = async () => {
  return await request({
    url: `${SERVER}/signages`,
    method: 'GET',
  });
};

// Subida de archivos
export const uploadFiles = async (data: any, documentType: string, filename: string) => {
  const formData = new FormData();
  formData.append('files', data);
  formData.append('documentType', documentType.trim());
  formData.append('filename', filename.trim());

  return await request({
    url: `${SERVER}/documents/temporal`,
    method: 'POST',
    data: formData,
  });
};

export const saveDeclaration = async (data: any) => {
  return await request({
    url: `${SERVER}/claims`,
    method: 'POST',
    data: data,
  });
};

export const getUrlFile = async (filename: string) => {
  return await request({
    url: `${SERVER}/documents/temporal?filename=${filename}`,
    method: 'GET',
    // Headers: {
    //   "Content-disposition": "inline; filename=filename",
    // }
  });
};

export const getUrlFileBase64 = async (filename: string) => {
  return await request({
    url: `${SERVER}/documents/temporal/view?filename=${filename}`,
    method: 'GET',
    // Headers: {
    //   "Content-disposition": "inline; filename=filename",
    // }
  });
};

export const putBase64File = async (data: any, folder?: string) => {
  if (folder === 'temporal') {
    return await request({
      url: `${SERVER}/documents/temporal/base64`,
      method: 'POST',
      data,
    });
  } else {
    return await request({
      url: `${SERVER}/documents/pss/base64`,
      method: 'POST',
      data,
    });
  }
};

export const getShortId = async () => {
  return await request({
    url: `${SERVER}/claims/short-id`,
    method: 'GET',
  });
};
